import React, { useEffect, useState } from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate, useLocation, Link } from 'react-router-dom';

function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const federatedConfig = {
    googleClientId: '82013007351-vle9ukfv9847u9aaea4v6b4vr6vil0go.apps.googleusercontent.com',
  };

  const { user, signOut, route } = useAuthenticator((context) => [context.user, context.route]);

  const TermsPrivacyLinks = () => (
    <div style={{ marginTop: '1em', textAlign: 'center' }}>
      <Link to="/terms" style={{ margin: '0 0.5em' }}>利用規約</Link>
      <span style={{ margin: '0 0.5em' }}>|</span>
      <Link to="/privacy" style={{ margin: '0 0.5em' }}>プライバシーポリシー</Link>
    </div>
  );

  const SignInFooter = () => {
    const { toResetPassword } = useAuthenticator();
    return (
      <>
        <div style={{ marginTop: '1em', textAlign: 'center' }}>
          <button
            onClick={(e) => { e.preventDefault(); toResetPassword(); }}
            style={{
              background: 'none',
              border: 'none',
              color: '#007bff',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
            }}
          >
            パスワードを忘れた場合
          </button>
        </div>
        <TermsPrivacyLinks />
      </>
    );
  };

  const components = {
    ConfirmSignUp: {
      Footer: () => (
        <details style={{ marginTop: '1em', textAlign: 'left' }}>
          <summary>メールが届かない時は？</summary>
          <ul style={{ marginTop: '0.5em', paddingLeft: '1.2em' }}>
            <li>迷惑メール判定（スパム）されている可能性があります。迷惑メールフォルダやフィルター設定をご確認ください。</li>
            <li>入力したメールアドレスに誤りがある可能性があります。再度メールアドレスを確認して送信し直してください。</li>
          </ul>
        </details>
      ),
    },
    SignIn: { Footer: SignInFooter },
    SignUp: { Footer: TermsPrivacyLinks },
  };

/*  const registerCustomer = async (user) => {
    const name = user?.attributes?.name || user?.username || 'Unknown';
    const email = user?.attributes?.email || 'no-email@example.com';

    try {
      const response = await fetch('https://mfcapi.ykvario.com/smaregiHandler.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: name,
          email: email,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const customerCode = data.customerCode;
        const customerId = data.customerId;

        // カスタマーコードとカスタマーIDをローカルストレージに保存
        localStorage.setItem('customerCode', customerCode);
        localStorage.setItem('customerId', customerId);
        console.log('Customer code and ID registered or fetched:', customerCode, customerId);

        // ログイン成功後にリダイレクトする条件を設定
        setShouldRedirect(true);
      } else {
        const errorData = await response.json();
        console.error('Failed to register customer in Smaregi:', errorData);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };*/

  useEffect(() => {
    if (user && route === 'authenticated') {
      //registerCustomer(user);
      setShouldRedirect(true);
    }
  }, [user, route]);

  useEffect(() => {
    if (shouldRedirect) {
      // 元の場所を取得し、デフォルトは "/" にする
      const from = location.state?.from?.pathname || '/';
      setTimeout(() => {
        navigate(from); // 元のページにリダイレクト
      }, 10);
    }
  }, [shouldRedirect, navigate, location]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', marginTop:'70px' }}>
      <Authenticator federated={federatedConfig}
      components={components}
      signUpAttributes={['email','phone_number']}
      formFields={{
        signUp: {
          phone_number: {
            dialCode: '+81', // 日本の場合
            label: '電話番号',
            placeholder: '+81901234567',
          },
        },
      }}
      >
        {() => (
          <main style={{ textAlign: 'center' }}>
            <h1>Welcome, {user?.username}</h1>
            <h2>Now loading...</h2>
            <button onClick={signOut}>Sign Out</button>
            <button onClick={() => navigate('/')}>Homeに戻る</button>
          </main>
        )}
      </Authenticator>
    </div>
  );
}

export default SignIn;
